import {Pipe, PipeTransform} from '@angular/core';
import {toLocaleProperCase} from '../../utils';

@Pipe({name: 'localeProperCase'})
export class LocaleProperCase implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return toLocaleProperCase(value);
  }
}
